export default (() => {
  "use strict";

  /**
   * @param breakpoints {Array}
   *    [
   *      100, // MIN BREAKPOINT Or false if no min
   *      800 // MAX BREAKPOINT Or false if no max
   *    ]
   *
   * Detects media query is reached before initiating the module, uses resize event listener to initialise the module
   * when this breakpoint is reached
   */

  const getBreakpointString = breakpoints => {
    if (breakpoints.length !== 2) return false;
    if (
      breakpoints[0] > breakpoints[1] &&
      breakpoints[0] !== false &&
      breakpoints[1] !== false
    )
      return false;

    let breakpointStr = "";

    const breakPointPrefix = ["(min-width: ", "(max-width: "];

    breakpoints.forEach((pixelValue, i) => {
      breakpointStr +=
        pixelValue !== false ? `${breakPointPrefix[i]}${pixelValue}px)` : "";

      if (i === 0 && breakpointStr.length > 0 && breakpoints[i + 1] !== false)
        breakpointStr += " and ";
    });

    return breakpointStr;
  };

  /**
   * @param breakpoints {Array}
   *    [
   *      100, // MIN BREAKPOINT Or false if no min
   *      800 // MAX BREAKPOINT Or false if no max
   *    ]
   *
   * Detects media query is reached before initiating the module, uses resize event listener to initialise the module
   * when this breakpoint is reached
   */

  const getMedia = breakpoints => {
    const breakpointString = getBreakpointString(breakpoints);

    if (!breakpointString) return false;

    return window.matchMedia(breakpointString);
  };

  return {
    getMedia
  };
})();
